import { render, staticRenderFns } from "./SignOralComponentImage.vue?vue&type=template&id=3d8e5ed1&"
import script from "./SignOralComponentImage.vue?vue&type=script&lang=ts&"
export * from "./SignOralComponentImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports